import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import { StyledHero, StyledHeroPhoto, StyledHeroCopy } from './styled';
import { StyledInfoIcon, StyledReactTooltip } from '../../globalStyled';
import LeagueSwitcher from '../LeagueSwitcher';
import img from '../../assets/img/cup-hero.jpg';
import { domesticCupLeaguesRequest } from '../../redux/actions/DomesticCup';
import { isLeaguesListLoaded } from '../../redux/selector/League';
import { domesticTableLoading } from '../../redux/selector/DomesticCup';
import { phaseToRound } from '../../service/data';

const LeagueCup = ({ phase, leagueId }) => {
  const dispatch = useDispatch();
  const leagueOptionsList = useSelector(isLeaguesListLoaded);
  const isTableLoading = useSelector(domesticTableLoading);
  const roundLabel = phaseToRound[phase] || '';

  const selectLeagueFromList = (id) => {
    dispatch(domesticCupLeaguesRequest(id));
  };

  return (
    <StyledHero>
      <StyledHeroPhoto>
        <img src={img} alt="" />
      </StyledHeroPhoto>
      <StyledHeroCopy>
        <h1>
          League Cup
          <StyledInfoIcon
            iconsize="14"
            data-tip
            clickable="true"
            data-for="league-cup-tooltip"
          />
          <StyledReactTooltip
            id="league-cup-tooltip"
            type="light"
            effect="solid"
            place="bottom"
          >
            THE LEAGUE CUP is our single-elimination tournament. The 10 teams in
            a league play each other over the course of the season to crown the
            cup winner
          </StyledReactTooltip>
        </h1>
        {roundLabel ? <p>{roundLabel}</p> : null}
      </StyledHeroCopy>
      {!isEmpty(leagueOptionsList) ? (
        <LeagueSwitcher
          leagues={leagueOptionsList}
          value={leagueId}
          onChange={selectLeagueFromList}
          disabled={isTableLoading}
        />
      ) : null}
    </StyledHero>
  );
};

LeagueCup.propTypes = {
  phase: PropTypes.number,
  leagueId: PropTypes.string,
};

LeagueCup.defaultProps = {
  phase: null,
  leagueId: null,
};

export default React.memo(LeagueCup);
